const messageGetter = x => x.message;

export function defaultValidatorErrorsParser(errors) {
  return Object.keys(errors).reduce((acc, x) => {
    acc[x] = errors[x].map(messageGetter);
    return acc;
  }, {});
}
